/* eslint class-methods-use-this:0 */
import app from '../store/modules/app';

class ErrorHandler {
  showError(errorMsg, type) {
    if ((type !== 'important' || type !== undefined) && process.env.NODE_ENV !== 'production') {
      console.error('Error Type should be important or undefined!');
    }
    app.commit('SHOW_ERROR', { errorMsg, type });
  }

  closeError() {
    app.commit('CLOSE_ERROR');
  }
}

const errorHandler = new ErrorHandler();

export default errorHandler;
